<template>
  <v-dialog
    v-model="show"
    persistent
    @keydown.esc="hide"
    width="500"
    v-if="role('admin', 'departmentManager', 'manager', 'safetyRepresentative')"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small class="primary accent-4 white--text mr-2 my-1">
        {{ $t(`profile.assignment.modes.button`) }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>{{
        $t(`profile.assignment.modes.dialog`)
      }}</v-card-title>
      <v-card-text>
        <v-autocomplete
          class="mt-0 pt-0"
          v-model="newModes"
          :items="allModes"
          required
          chips
          :deletable-chips="!!Array.isArray(newModes) && !!newModes.length"
          item-text="name"
          return-object
          multiple
        />
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey" text @click="hide">{{ $t("dialog.cancel") }}</v-btn>

        <v-btn color="primary" text @click="save" :loading="loading">{{
          $t("dialog.assign")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ModesQuery from "@/graphql/queries/mode/Modes.gql";
import ChangeEmployeeModes from "@/graphql/ChangeEmployeeModes.gql";
import { mapGetters } from "vuex";

export default {
  props: ["id", "modes"],

  data() {
    return {
      show: false,
      newModes: [],
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["role"]),
  },
  mounted() {
    this.newModes = this.modes;
  },

  methods: {
    hide() {
      this.show = false;
    },
    save() {
      this.loading = true;
      const newModesIds = this.newModes.map((m) => m.id);
      this.$apollo
        .mutate({
          mutation: ChangeEmployeeModes,
          variables: {
            id: this.id,
            modes: newModesIds,
          },
        })
        .then((res) => {
          this.$emit("update:modes", res.data.employee.modes);
          this.$emit("refresh");
          this.hide();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  apollo: {
    allModes: {
      query: ModesQuery,
      update(data) {
        return data.modes;
      },
      skip() {
        return !this.show;
      },
      fetchPolicy: "cache-and-network",
    },
  },
};
</script>
